export default [
    [60, 60],
    [80, 80],
    [150, 150],
    [150, 100],
    [170, 96],
    [180, 270],
    [200, 200],
    [205, 137],
    [220, 147],
    [270, 180],
    [300, 300],
    [340, 191],
    [352, 235],
    [352, 198],
    [370, 247],
    [380, 214],
    [400, 400],
    [410, 273],
    [410, 231],
    [410, 164],
    [440, 293],
    [460, 307],
    [460, 259],
    [470, 264],
    [540, 360],
    [570, 380],
    [570, 321],
    [576, 384],
    [600, 600],
    [600, 338],
    [620, 349],
    [704, 469],
    [704, 396],
    [740, 493],
    [760, 428],
    [767, 511],
    [767, 431],
    [767, 307],
    [768, 512],
    [768, 432],
    [768, 384],
    [768, 307],
    [770, 433],
    [780, 439],
    [820, 547],
    [820, 461],
    [820, 328],
    [920, 613],
    [920, 518],
    [920, 368],
    [940, 529],
    [970, 546],
    [980, 653],
    [980, 551],
    [980, 392],
    [1140, 760],
    [1140, 641],
    [1150, 767],
    [1150, 647],
    [1150, 460],
    [1200, 800],
    [1200, 675],
    [1200, 480],
    [1534, 863],
    [1536, 864],
    [1536, 768],
    [1536, 614],
    [1536, 1024],
    [1540, 866],
    [1560, 878],
    [1600, 640],
    [1600, 1067],
    [1940, 1091],
    [1960, 784],
    [1960, 1307],
    [1960, 1103],
    [2400, 690],
    [2400, 1600],
    [2400, 1350],
    [3200, 2133],
    [3200, 1800],
    [3200, 1280],
    [3840, 2560],
];
